var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      ref: "button",
      class: {
        underline: _vm.underline,
        nostyle: _vm.nostyle,
        "full-width": _vm.fullWidth,
        loading: _vm.loading,
        disabled: _vm.disabled
      },
      attrs: { disabled: _vm.disabled, href: _vm.href, target: _vm.linkTarget },
      on: {
        click: _vm.click,
        keydown: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") &&
            _vm._k($event.keyCode, "space", 32, $event.key, " ")
          ) {
            return null
          }
          return _vm.click($event)
        }
      }
    },
    [_vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc500de2", { render: render, staticRenderFns: staticRenderFns })
  }
}